module.exports = __webpack_public_path__ + "static/media/micro-loan.75545e29.svg";